import { Controller } from "@/controllers/Controller";

/**
 * Controller for French Directory Cache API
 */
export class FrenchDirectoryController extends Controller {

    static listEntriesOfCompany(siren) {
        return this.requestBuilder("GET", `/ms-transmission/french-directory/list-entries-of-company?siren=${siren}`, true);
    }

    static listCompanies(params) {
        return this.requestBuilder("GET", `/ms-transmission/french-directory/list-companies${params}`, true);
    }

}
